precision highp float;

varying vec3 vColor;
varying float vTwinkle;

// Soft round LED: hot core, exponential halo. Additive blending turns
// overlapping halos into the volumetric glow of a real drone light.
void main() {
  vec2 uv = gl_PointCoord - 0.5;
  float r = length(uv);
  if (r > 0.5) discard;

  float core = smoothstep(0.5, 0.0, r);
  float halo = pow(core, 2.4);
  vec3 c = vColor * vTwinkle * (0.35 + halo * 1.15);

  gl_FragColor = vec4(c, core);
}
